module.exports = "/images/no-avatar.png?91eb3221c85873fb856995c8791edd66";